import { render, staticRenderFns } from "./ReportCuitf17Page.vue?vue&type=template&id=604c127c&scoped=true"
import script from "./ReportCuitf17Page.vue?vue&type=script&lang=js"
export * from "./ReportCuitf17Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604c127c",
  null
  
)

export default component.exports